import React, {useEffect, useState} from 'react'
import FailedModal from "../../CustomModal/Failed";
import Loader from "../../../Loader/Loader";
import DashboardMenu from "../../layout/dashboardMenu";
import Header from "../../layout/header";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import SuccessModal from "../../CustomModal/Success";

const Opportunity = (
    {
        match,
        history,
        dropdownData,
        dropdownValue=[],
        saveForBA,
        saveDetails
    }
) => {

    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isAllow, setIsAllow] = useState(false);
    const [inputList, setInputList] = useState([{
        lat: islatlng?.lat,
        long: islatlng?.lng,
        opportunity_type_id:'',
        account_id:'',
        lead_id:'',
        details: {
            lead_status:'',
            follow_up_date:'',
            signed:'',
            payment_structure:'',
            cheque:'',
            quantity_pitched:'',
            price_pitched:'',
            agreement_duration:'',
            payment_period:'',
            dropped_reason:''
        }
    }])

    useEffect(async () => {
        setIsLoading(true)
        await dropdownData("is_ba")
        setIsLoading(false)
    }, [])

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
    }, [islatlng]);

    const handleInput = (key, val) => {
        let list = [...inputList]
        list[0][key] = val
        setInputList(list)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        inputList[0]['lat'] = islatlng?.lat
        inputList[0]['long'] = islatlng?.lng
        if(inputList[0]['lat'] == null || inputList[0]['long'] == null){
            toast.error('Please enable your location');
            return false
        }
        inputList[0]['lead_id'] = match?.params?.lead_id
        inputList[0]['is_ba_type'] = true
        setIsLoading(true)
        await saveForBA(inputList[0])
        setIsLoading(false)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveDetails?.status === 200) {
            setIsSuccessModalOpen(true)
        } else if (saveDetails?.status !== undefined && saveDetails?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [saveDetails])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={saveDetails?.message}
                url={`ba-opportunity-list/${match?.params?.lead_id}`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={saveDetails?.message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                                <>
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    {/*<h1 className="h3 mb-0 text-black-100">*/}
                                                    {/*    <span style={{color: "green"}}>{distance}</span>*/}
                                                    {/*</h1>*/}
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 float-field uu-select">
                                                                <select className="form-control form-control-user"
                                                                        onChange={(e) => {
                                                                            handleInput('opportunity_type_id', e.target.value)
                                                                        }} required>
                                                                    <option value="">Select Opportunity Type</option>
                                                                    {dropdownValue?.opportunity_types !== undefined && dropdownValue?.opportunity_types.map((val) => {
                                                                        return (
                                                                            <option
                                                                                value={val?.id}>{val.name}</option>
                                                                        )
                                                                    })}

                                                                </select>
                                                                <label className="large-label float-lb">
                                                                    Opportunity Type
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-4 d-flex">
                                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Opportunity